import { useActiveConversation } from '../../chat/ActiveConversationContext';

// Hands a message off to a FRESH floating-chat thread. Imperative (the store's
// `openChatWithMessage`) rather than the `?new=1&prefill=…&autosend=1` URL, for the same reason
// the composer's own submit is — see the comment on `HomeComposer.submit`.
export function useHomeHandoff() {
  const { openChatWithMessage } = useActiveConversation();
  return (message: string) => {
    const trimmed = message.trim();
    if (!trimmed) return;
    openChatWithMessage({ kind: 'new', message: trimmed });
  };
}
